import axios from 'axios';
import {api} from '../constants/api';
import {errors as E} from 'common/constants/errors';

export const getShumaBasicData = ({
                                  shumaId,
                                }) => dispatch => {
  const data = {
    selectedShumaID: shumaId
  };

  return axios.post(api.GET_SHUMA_BASIC_DATA, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      return body.basicData[0];
    });
};
